import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectDbnpMappingListItems } from "../../../../../../redux/dbnp-mappings/selector";
import { dbnpMappings } from "../../../../../../redux/dbnp-mappings/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const DbnpMappings = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const dbnpMappingItems = useSelector(selectDbnpMappingListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'ConsumerDBNIEName', headerName: 'Consumer DBNIE Name'},
      { field: 'ConsumerDBNPName', headerName: 'Consumer DBNP Name'},
      { field: 'ProviderDBNIEName', headerName: 'Provider DBNIE Name'},
      { field: 'ProviderDBNPName', headerName: 'Provider DBNP', searchField: 'ProviderDBNPName', sortable: true, filter: true, filterType: 'text' },
      { field: 'ISDBNPProviderEnabled', headerName: 'DBNP Provider Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDBNPConsumerEnabled', headerName: 'DBNP Consumer Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDBNPPartnerRoleEnabled', headerName: 'DBNP Partner Role Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDBNPSupplierRoleEnabled', headerName: 'DBNP Supplier Role Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDBNPVendorRoleEnabled', headerName: 'DBNP Vendor Role Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const fetchDbnpMapping = () => {
    dispatch(dbnpMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings/list`,
      entity: 'dbnpMappings',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleDelete = (data: any) => {
    dispatch(dbnpMappings.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings/delete`,
      entity: 'dbnpMappings',
      jsonData: {
        "Context": {},
        "Records": [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(dbnpMappings.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings/list`,
        entity: 'dbnpMappings',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  useEffect(() => {
    createColumnDefs()
    fetchDbnpMapping()
  }, [pageData, pageSize])

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add DBNP Mappings</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add DBNP Mappings',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  const handleReloadData = () => {
    fetchDbnpMapping();
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(dbnpMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings/list`,
      entity: 'dbnpMappings',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (item: any, checked: any) => {
    console.log("Item", checked, item)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    console.log("Items count", checked, items?.length)
    console.log('items', items)
  }

    return (
      <>
        {dbnpMappingItems?.isLoading ? <PageLoader /> :
          <Table columnData={columnDefs} rowData={dbnpMappingItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
            enableFilter={true} onSearch={handleSearch} onSelect={handleSelect} onSelectAll={handleSelectAll}
            paginationData={dbnpMappingItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
            additionButtons={additionButtons} headingName="DBNP Mappings" />
        }
      </>
    );
  };

  export default DbnpMappings;
